var _linearGradient, _linearGradient2, _linearGradient3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogledrive = function SvgGoogledrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 23.3"
  }, props), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "googledrive_svg__b",
    x1: 27,
    x2: 14.2,
    y1: -939.7,
    y2: -931.9,
    gradientTransform: "matrix(1 0 0 -1 0 -919.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec700"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "googledrive_svg__c",
    x1: 15.6,
    x2: 1.5,
    y1: -942.3,
    y2: -933.8,
    gradientTransform: "matrix(1 0 0 -1 0 -919.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#a9a8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6d97ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#3186ff"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "googledrive_svg__d",
    x1: 16.6,
    x2: 2.4,
    y1: -921.4,
    y2: -928,
    gradientTransform: "matrix(1 0 0 -1 0 -919.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ebc5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#78c9ff"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "googledrive_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8 3.4c2.1-3.6 7.3-3.6 9.4 0l6.4 11.1c2.1 3.6-.5 8.1-4.7 8.1H6.1c-4.1 0-6.7-4.5-4.7-8.1z",
    style: {
      fill: "none"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.1 23.3c-2.2 0-4.2-1.1-5.3-3.1a6.05 6.05 0 0 1 0-6.1l6.4-11C8.3 1.2 10.3 0 12.5 0s4.2 1.1 5.3 3.1l6.4 11.1c1.1 1.9 1.1 4.2 0 6.1s-3.1 3.1-5.3 3.1H6.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#googledrive_svg__a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2 22.6h-13l-2.7-4.7L19 6.6z",
    style: {
      fill: "url(#googledrive_svg__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.2 22.6 6 6.6l-2.7 4.7h5.4l6.5 11.3z",
    style: {
      fill: "url(#googledrive_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5-4.7 19 6.6l-2.7 4.7h-13z",
    style: {
      fill: "url(#googledrive_svg__d)"
    }
  })));
};
export default SvgGoogledrive;